bcn.gtmDonation = (function () {

  'use strict';

  function pushTransaction(details) {
    window.dataLayer = window.dataLayer || []
    dataLayer.push({
      'transactionId': details.data("transactionId"),
      'transactionTotal': details.data("amount"),
      'transactionProducts': [{
        'sku': details.data("productName"),
        'name': details.data("productName"),
        'category': details.data("category"),
        'price': details.data("amount"),
        'quantity': 1
      }]
    });
  }


  return {
    init: function () {
      var details = $('#completed_donation_details');

      if (!details ) {
        return;
      }

      pushTransaction(details);

    }
  };

})();
